//
//
//
//
//
//
//
//
//

import { BModal, BButton } from 'bootstrap-vue';

export default {
  name: "PromoModal",
  components: { BModal },
  props: {
    title: {
      type: [String, Object],
      required: true
    },
    imgSrc: {
      type: String,
      required: true
    },
    imgAlt: {
      type: String,
      default: ''
    },

  },
  data() {
    return {
      modalShow: false
    }
  },
  methods: {
    showModal() {
      this.modalShow = true;
    },
    hideModal() {
      this.modalShow = false;
    }
  }
};
